var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.60413V12.4166",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3234 8.36507V14.635C19.3234 15.6617 18.7733 16.6151 17.8842 17.1376L12.4392 20.2817C11.55 20.7951 10.45 20.7951 9.55166 20.2817L4.10665 17.1376C3.21749 16.6242 2.66748 15.6709 2.66748 14.635V8.36507C2.66748 7.33841 3.21749 6.38503 4.10665 5.86253L9.55166 2.71837C10.4408 2.20504 11.5408 2.20504 12.4392 2.71837L17.8842 5.86253C18.7733 6.38503 19.3234 7.32924 19.3234 8.36507Z",
    stroke: "#596780",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.35V15.4416",
    stroke: "#596780",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskAssessment);
export default __webpack_public_path__ + "static/media/riskAssessment.db8e3356e3711c6dc4d6c66c7d1eac22.svg";
export { ForwardRef as ReactComponent };